module.exports = __webpack_public_path__ + "img/newyear_title3.8e348097.png";